import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2, Settings2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/axios';
import { ReglasForm } from './ReglasForm';
import { reglasFromApi, reglasToApi, toNum } from './vigilanciaUtils';

export const EditarVigilanciaDialog = ({ vig, onOpenChange, onSaved }) => {
  const [form, setForm] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (vig) setForm({
      intervalo_min: vig.intervalo_min, saldo_referencia: vig.saldo_referencia ?? '', reglas: reglasFromApi(vig.reglas),
    });
  }, [vig]);

  const guardar = async () => {
    setGuardando(true);
    try {
      const { data } = await api.put(`/vigilancia/cuentas/${vig.id}`, {
        intervalo_min: form.intervalo_min, saldo_referencia: toNum(form.saldo_referencia), reglas: reglasToApi(form.reglas),
      });
      toast.success('Configuración guardada');
      onSaved?.(data);
      onOpenChange(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo guardar');
    } finally { setGuardando(false); }
  };

  return (
    <Dialog open={!!vig} onOpenChange={onOpenChange}>
      <DialogContent className="vig-scope max-w-2xl" data-testid="vig-editar-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Settings2 size={18} className="text-teal-700" /> Alertas de {vig?.nombre}</DialogTitle>
          <DialogDescription className="font-mono text-xs">CVU {vig?.cvu || '—'} · CUIT {vig?.cuit}</DialogDescription>
        </DialogHeader>
        {form && <ReglasForm value={form} onChange={setForm} />}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={guardar} disabled={guardando} className="bg-teal-700 hover:bg-teal-800" data-testid="vig-editar-guardar-btn">
            {guardando && <Loader2 size={16} className="mr-1.5 animate-spin" />} Guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditarVigilanciaDialog;
